import React from 'react';
import {
  Home,
  Search,
  Plus,
  User,
  Settings,
  Type,
  LogOut,
  Sun,
  Moon,
  Wand2,
  Copy,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Heart,
  Pencil,
  Trash2,
  Star,
  UploadCloud,
  File,
  Sparkles,
  Image,
  Video,
  Clock,
  Download,
  AlertTriangle,
  Camera,
  Scan,
  CheckCircle2,
  RefreshCw,
  Clapperboard,
  Aperture,
  Palette,
  Lightbulb,
  BookOpen,
  Lock,
  Zap,
  UserCheck,
  SlidersHorizontal,
  X,
  ExternalLink,
  HelpCircle,
  FileText,
  PanelLeft,
  Crown,
  FolderPlus,
  Layers,
  Bookmark,
  Share2,
  Eye,
  Filter,
  Play,
  Save,
  ArrowUp,
  ArrowDown,
  ArrowRight,
  Crosshair,
  Maximize,
  LayoutDashboard,
  Folder,
  Undo2,
  Move,
  LucideProps,
} from 'lucide-react';

export type IconProps = LucideProps & React.SVGProps<SVGSVGElement>;

export interface FillableIconProps extends IconProps {
  filled?: boolean;
}

// ---------------------------------------------------------------------------
// Standard System / UI Icons (powered by Lucide with consistent 1.75px stroke)
// ---------------------------------------------------------------------------

export const HomeIcon: React.FC<IconProps> = (props) => <Home strokeWidth={1.75} {...props} />;
export const SearchIcon: React.FC<IconProps> = (props) => <Search strokeWidth={1.75} {...props} />;
export const PlusIcon: React.FC<IconProps> = (props) => <Plus strokeWidth={1.75} {...props} />;
export const UserIcon: React.FC<IconProps> = (props) => <User strokeWidth={1.75} {...props} />;
export const SettingsIcon: React.FC<IconProps> = (props) => <Settings strokeWidth={1.75} {...props} />;
export const FontIcon: React.FC<IconProps> = (props) => <Type strokeWidth={1.75} {...props} />;
export const LogoutIcon: React.FC<IconProps> = (props) => <LogOut strokeWidth={1.75} {...props} />;
export const SunIcon: React.FC<IconProps> = (props) => <Sun strokeWidth={1.75} {...props} />;
export const MoonIcon: React.FC<IconProps> = (props) => <Moon strokeWidth={1.75} {...props} />;
export const MagicWandIcon: React.FC<IconProps> = (props) => <Wand2 strokeWidth={1.75} {...props} />;
export const CopyIcon: React.FC<IconProps> = (props) => <Copy strokeWidth={1.75} {...props} />;
export const CheckIcon: React.FC<IconProps> = (props) => <Check strokeWidth={2.25} {...props} />;
export const ChevronDownIcon: React.FC<IconProps> = (props) => <ChevronDown strokeWidth={2} {...props} />;
export const ChevronLeftIcon: React.FC<IconProps> = (props) => <ChevronLeft strokeWidth={2} {...props} />;
export const ChevronRightIcon: React.FC<IconProps> = (props) => <ChevronRight strokeWidth={2} {...props} />;

export const HeartIcon: React.FC<FillableIconProps> = ({ filled = false, className = '', ...props }) => (
  <Heart
    strokeWidth={1.75}
    fill={filled ? "currentColor" : "none"}
    className={className}
    {...props}
  />
);

export const EditIcon: React.FC<IconProps> = (props) => <Pencil strokeWidth={1.75} {...props} />;
export const TrashIcon: React.FC<IconProps> = (props) => <Trash2 strokeWidth={1.75} {...props} />;
export const StarIcon: React.FC<IconProps> = (props) => <Star strokeWidth={1.75} {...props} />;
export const UploadCloudIcon: React.FC<IconProps> = (props) => <UploadCloud strokeWidth={1.75} {...props} />;
export const FileIcon: React.FC<IconProps> = (props) => <File strokeWidth={1.75} {...props} />;
export const SparklesIcon: React.FC<IconProps> = (props) => <Sparkles strokeWidth={1.75} {...props} />;
export const ImageIcon: React.FC<IconProps> = (props) => <Image strokeWidth={1.75} {...props} />;
export const VideoIcon: React.FC<IconProps> = (props) => <Video strokeWidth={1.75} {...props} />;
export const ClockIcon: React.FC<IconProps> = (props) => <Clock strokeWidth={1.75} {...props} />;
export const DownloadIcon: React.FC<IconProps> = (props) => <Download strokeWidth={1.75} {...props} />;
export const AlertTriangleIcon: React.FC<IconProps> = (props) => <AlertTriangle strokeWidth={1.75} {...props} />;
export const CameraIcon: React.FC<IconProps> = (props) => <Camera strokeWidth={1.75} {...props} />;
export const ScanIcon: React.FC<IconProps> = (props) => <Scan strokeWidth={1.75} {...props} />;
export const CheckCircleIcon: React.FC<IconProps> = (props) => <CheckCircle2 strokeWidth={2} {...props} />;
export const RefreshCwIcon: React.FC<IconProps> = (props) => <RefreshCw strokeWidth={1.75} {...props} />;
export const ClapperboardIcon: React.FC<IconProps> = (props) => <Clapperboard strokeWidth={1.75} {...props} />;
export const CameraApertureIcon: React.FC<IconProps> = (props) => <Aperture strokeWidth={1.75} {...props} />;
export const PaletteIcon: React.FC<IconProps> = (props) => <Palette strokeWidth={1.75} {...props} />;
export const LightbulbIcon: React.FC<IconProps> = (props) => <Lightbulb strokeWidth={1.75} {...props} />;
export const BookOpenIcon: React.FC<IconProps> = (props) => <BookOpen strokeWidth={1.75} {...props} />;
export const LockIcon: React.FC<IconProps> = (props) => <Lock strokeWidth={1.75} {...props} />;
export const ZapIcon: React.FC<IconProps> = (props) => <Zap strokeWidth={1.75} {...props} />;
export const UserCheckIcon: React.FC<IconProps> = (props) => <UserCheck strokeWidth={1.75} {...props} />;
export const SlidersIcon: React.FC<IconProps> = (props) => <SlidersHorizontal strokeWidth={1.75} {...props} />;
export const XIcon: React.FC<IconProps> = (props) => <X strokeWidth={2} {...props} />;
export const ExternalLinkIcon: React.FC<IconProps> = (props) => <ExternalLink strokeWidth={1.75} {...props} />;
export const HelpCircleIcon: React.FC<IconProps> = (props) => <HelpCircle strokeWidth={1.75} {...props} />;
export const FileTextIcon: React.FC<IconProps> = (props) => <FileText strokeWidth={1.75} {...props} />;
export const PanelLeftIcon: React.FC<IconProps> = (props) => <PanelLeft strokeWidth={1.75} {...props} />;
export const CrownIcon: React.FC<IconProps> = (props) => <Crown strokeWidth={1.75} {...props} />;
export const FolderPlusIcon: React.FC<IconProps> = (props) => <FolderPlus strokeWidth={1.75} {...props} />;
export const LayersIcon: React.FC<IconProps> = (props) => <Layers strokeWidth={1.75} {...props} />;
export const BookmarkIcon: React.FC<IconProps> = (props) => <Bookmark strokeWidth={1.75} {...props} />;
export const ShareIcon: React.FC<IconProps> = (props) => <Share2 strokeWidth={1.75} {...props} />;
export const EyeIcon: React.FC<IconProps> = (props) => <Eye strokeWidth={1.75} {...props} />;
export const FilterIcon: React.FC<IconProps> = (props) => <Filter strokeWidth={1.75} {...props} />;
export const PlayIcon: React.FC<IconProps> = (props) => <Play strokeWidth={1.75} {...props} />;
export const SaveIcon: React.FC<IconProps> = (props) => <Save strokeWidth={1.75} {...props} />;
export const ArrowUpIcon: React.FC<IconProps> = (props) => <ArrowUp strokeWidth={1.75} {...props} />;
export const ArrowDownIcon: React.FC<IconProps> = (props) => <ArrowDown strokeWidth={1.75} {...props} />;
export const ArrowRightIcon: React.FC<IconProps> = (props) => <ArrowRight strokeWidth={2} {...props} />;
export const CrosshairIcon: React.FC<IconProps> = (props) => <Crosshair strokeWidth={1.75} {...props} />;
export const MaximizeIcon: React.FC<IconProps> = (props) => <Maximize strokeWidth={1.75} {...props} />;
export const LayoutDashboardIcon: React.FC<IconProps> = (props) => <LayoutDashboard strokeWidth={1.75} {...props} />;
export const FolderIcon: React.FC<IconProps> = (props) => <Folder strokeWidth={1.75} {...props} />;
export const UndoIcon: React.FC<IconProps> = (props) => <Undo2 strokeWidth={1.75} {...props} />;
export const MoveIcon: React.FC<IconProps> = (props) => <Move strokeWidth={1.75} {...props} />;

// ---------------------------------------------------------------------------
// Official AI Provider & Platform Brand Logos (High-Fidelity SVGs)
// ---------------------------------------------------------------------------

/**
 * Official OpenAI Rosette Vortex Logo
 */
export const OpenAiIcon: React.FC<IconProps> = ({ className = "h-5 w-5", ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729zm-9.022 12.6081a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1686a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4944zm-9.6607-4.1254a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.1408-1.6464zM2.3408 7.8956a4.485 4.485 0 0 1 2.3655-1.9728V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1685a.0757.0757 0 0 1-.071 0l-4.8303-2.7865A4.504 4.504 0 0 1 2.3408 7.872zm16.5963 3.8558L13.1038 8.364 15.1192 7.2a.0757.0757 0 0 1 .071 0l4.8303 2.7913a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.407-.6667zm2.0107-3.0231l-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.409 9.2297V6.8974a.0662.0662 0 0 1 .0284-.0615l4.8303-2.7866a4.4992 4.4992 0 0 1 6.6802 4.66zM8.3065 12.863l-2.02-1.1638a.0804.0804 0 0 1-.038-.0567V6.0742a4.4992 4.4992 0 0 1 7.3757-3.4537l-.142.0805L8.704 5.459a.7948.7948 0 0 0-.3927.6813zm1.0976-2.3654l2.602-1.4998 2.6069 1.4998v2.9994l-2.5974 1.4997-2.6067-1.4997Z" />
  </svg>
);

// Alias ChatGptIcon to OpenAiIcon so all existing usages automatically render the official logo
export const ChatGptIcon = OpenAiIcon;

/**
 * Official Google Gemini Astroid Star Logo
 */
export const GeminiIcon: React.FC<IconProps> = ({ className = "h-5 w-5", ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M12 0C12 6.627 6.627 12 0 12c6.627 0 12 5.373 12 12 0-6.627 5.373-12 12-12-6.627 0-12-5.373-12-12Z" />
  </svg>
);

/**
 * Official Anthropic Claude Radiant Starburst Logo
 */
export const ClaudeIcon: React.FC<IconProps> = ({ className = "h-5 w-5", ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M13.8 2.3a1 1 0 0 0-1.6 0l-1.3 2.5a1 1 0 0 1-.8.5l-2.8.2a1 1 0 0 0-.9 1.4l1.3 2.5c.3.5.2 1.1-.2 1.5l-2 2a1 1 0 0 0 .1 1.6l2.6 1.1c.5.2.8.7.8 1.2l-.2 2.8a1 1 0 0 0 1.4 1l2.5-1.3c.5-.3 1.1-.2 1.5.2l2 2a1 1 0 0 0 1.6-.1l1.1-2.6c.2-.5.7-.8 1.2-.8l2.8.2a1 1 0 0 0 1-1.4l-1.3-2.5c-.3-.5-.2-1.1.2-1.5l2-2a1 1 0 0 0-.1-1.6l-2.6-1.1c-.5-.2-.8-.7-.8-1.2l.2-2.8a1 1 0 0 0-1.4-1l-2.5 1.3c-.5.3-1.1.2-1.5-.2l-2-2z" />
  </svg>
);

/**
 * Official xAI Grok Logo
 */
export const GrokIcon: React.FC<IconProps> = ({ className = "h-5 w-5", ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

/**
 * Official Midjourney Sailing Ship Logo
 */
export const MidjourneyIcon: React.FC<IconProps> = ({ className = "h-5 w-5", ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M3 18c4.5 1.5 13.5 1.5 18 0" />
    <path d="M12 3v15" />
    <path d="M12 4l7 10H5l7-10z" />
  </svg>
);

/**
 * Official Flux / Black Forest Labs Geometric Crystal Logo
 */
export const FluxIcon: React.FC<IconProps> = ({ className = "h-5 w-5", ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <polygon points="12 2 21 7.5 21 16.5 12 22 3 16.5 3 7.5 12 2" />
    <line x1="12" y1="22" x2="12" y2="12" />
    <line x1="3" y1="7.5" x2="12" y2="12" />
    <line x1="21" y1="7.5" x2="12" y2="12" />
  </svg>
);


